import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography} from '@mui/material';
import './DialogBox.scss';

interface IDialogBoxButton {
  text: string;
  onPressed: () => void;
  variant?: 'text' | 'outlined' | 'contained';
}

interface IDialogBox {
  isOpen: boolean;
  title?: string;
  content?: string;
  buttons?: IDialogBoxButton[];
  footerType?: string;
  showIcon?: boolean;
  customIcon?: string;
  onClose?: () => void;
}
const DialogBox: React.FC<IDialogBox> = ({
  isOpen,
  title,
  content,
  buttons,
  footerType,
  showIcon = true,
  customIcon,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" className="dialog-component">
      <div className="dialog-wrapper">
        {title && (
          <DialogTitle className="dialog-title">
            {showIcon && customIcon && (
              <div className="dialog-image-wrapper">
                <img src={customIcon} className="dialog-image" alt="Icon" />
              </div>
            )}
            <Typography align="center" className="dialog-title-text">
              {title}
            </Typography>
          </DialogTitle>
        )}
        {content && (
          <DialogContent>
            <div>
              <Typography className="dialog-content-text">{content}</Typography>
            </div>
          </DialogContent>
        )}
        {buttons && buttons.length > 0 && (
          <DialogActions className="dialog-action-container">
            {buttons.map((button, index) => (
              <Button
                key={index}
                onClick={button.onPressed}
                variant={button.variant || (footerType === 'cancel' ? 'outlined' : 'contained')}
                className="dialog-button">
                {button.text}
              </Button>
            ))}
          </DialogActions>
        )}
      </div>
    </Dialog>
  );
};

export default DialogBox;
